// extracted by mini-css-extract-plugin
module.exports = {"loader":"Q","smallLoader":"R","loading-keyframes":"S","pageLoader":"T","centered":"U","whitespacePlaceholder":"V","buttonSpinner":"W","fade-in":"X","rotate":"Y"};